module.exports = __webpack_public_path__ + "media/images/modules/root_on_talkport/group-4e2b197d922a150d9e8ab8a3b11bb220.png";